// Verified against the restaurants' public Yandex Maps and 2GIS cards on 26 October 2026.
// Reviews and ratings are different counts on both platforms.
export const REVIEW_STATS = {
  yandex: {
    rating: "5,0",
    reviewCount: 5510,
    ratingCount: 5830,
    url: "https://yandex.ru/maps/org/parusa_na_kryshe/228378467058/reviews/",
  },
  twoGis: {
    rating: "4,9",
    reviewCount: 2780,
    ratingCount: 3026,
    url: "https://2gis.ru/spb/firm/70000001106091265/tab/reviews",
  },
} as const;

export function formatReviewCount(count: number): string {
  return count.toLocaleString("ru-RU");
}
